
import { Lang } from '@/lang/lang';

// 不要取这里的，这里大部分取系统字典了，后序全部替换成取系统字典
export const ctrlTypes = [
  {label: Lang.option.telemetry, name: '遥测', value: 1},
  {label: Lang.option.distantCommunication, name: '遥信', value: 2},
  {label: Lang.option.remoteAdjust, name: '遥调', value: 3},
  {label: Lang.option.remoteControl, name: '遥控', value: 4},
] 

export const yesOrNo = [
  {label: Lang.label.yes, name: '是', value: 1},
  {label: Lang.label.no, name: '否', value: 0},
] 

export const alarmLevels = [
  {label: Lang.option.generally, name: '一般', value: 1},
  {label: Lang.option.serious, name: '严重', value: 2},
  {label: Lang.option.urgent, name: '紧急', value: 3},
]

export const alarmTypes = [
  {label: Lang.option.signalStatus, name: '信号状态', value: 1},
  {label: Lang.option.theMoreCapped, name: '越上限', value: 2},
  {label: Lang.option.exceedTheUpperLimit, name: '越上上限', value: 3},
  {label: Lang.option.beyondTheLowerLimit, name: '越下限', value: 4},
  {label: Lang.option.lowerbounds, name: '越下下限', value: 5},
]

export const alarmTypeOption = [
  {label: Lang.option.signalStatus, name: '信号状态', value: 1},
  {label: Lang.option.theMoreCapped, name: '越上限', value: 2},
  {label: Lang.option.exceedTheUpperLimit, name: '越上上限', value: 3},
  {label: Lang.option.beyondTheLowerLimit, name: '越下限', value: 4},
  {label: Lang.option.lowerbounds, name: '越下下限', value: 5},
  {label: Lang.option.gatewayInterrupted, name: '网关通讯中断', value: 6},
  {label: Lang.option.deviceInterrupted, name: '设备通讯中断', value: 7},
]

export const dataTimeTypes = [
  // {label: Lang.option.onePoint, name: '1分', show: true, num: 1, dataType: 1, value: 'minute'},
  {label: Lang.option.fivePoints, name: '5分', show: true, num: 5, dataType: 2, value: 'minute'},
  {label: Lang.option.fifteenPoints, name: '15分', show: true, num: 15, dataType: 3, value: 'minute'},
  {label: Lang.option.thirtyMinutes, name: '30分', show: true, num: 30, dataType: 4, value: 'minute'},
  {label: Lang.option.hour, name: '小时', show: true, num: 1, dataType: 5, value: 'hour'},
  {label: Lang.option.daily, name: '日报', show: true, num: 1, dataType: 6, value: 'day'},
  {label: Lang.option.monthly, name: '月报', show: true, num: 1, dataType: 7, value: 'month'},
  {label: Lang.option.yearly, name: '年报', show: true, num: 1, dataType: 8, value: 'year'},
]

export const compareTypes = [
  {label: Lang.label.no, name: '否', value: 0},
  {label: Lang.option.YoY, name: '同比', value: 1},
  {label: Lang.option.MoM, name: '环比', value: 2},
  {label: Lang.option.YoYAndMoM, name: '同环比', value: 3},
]